var Minibus = require('minibus');
export const EventBus = Minibus.create();
